import { jsx as _jsx } from "react/jsx-runtime";
import { queryClient } from '@as-react/common-queries';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { useZitcha } from '../../hooks/useZitcha';
import { useEffect } from 'react';
const Bootstrap = () => {
    const { collectPageview } = useZitcha();
    useEffect(() => {
        collectPageview();
    }, []);
    return _jsx(ReactQueryDevtools, { client: queryClient });
};
export default Bootstrap;
